import React, { useEffect, useState } from "react";
import { login } from "../../services/userServices";
import { useTranslation } from "react-i18next";
import { getCompanyUniqueKey, getLogoPath } from "../../helpers/utils";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { notification } from "../../helpers/notification";

export const ChefLoginContainer = () => {
  const [loginState, setState] = useState({
    identityNumber: "",
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [recaptchaStatus, setRecaptchaStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const savedRememberMe = window.localStorage.getItem("remember_chef_me") === "true";
    const savedIdentity = window.localStorage.getItem("remember_chef_identity");
    if (savedRememberMe && savedIdentity) {
      setRememberMe(true);
      setState((prev) => ({
        ...prev,
        identityNumber: savedIdentity,
      }));
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const submit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (!recaptchaStatus || isLoading) return;

    setIsLoading(true);
    login({
      identityNumber: loginState.identityNumber,
      oggNumber: "111111",
      companyUniqueKey: getCompanyUniqueKey(),
      isChefLogin: true,
    })
      .then((response) => {
        notification.success({ message: "Giriş İşlemi Başarılı" });

        if (rememberMe) {
          window.localStorage.setItem("remember_chef_identity", loginState.identityNumber);
          window.localStorage.setItem("remember_chef_me", "true");
        } else {
          window.localStorage.removeItem("remember_chef_identity");
          window.localStorage.removeItem("remember_chef_me");
        }

        window.localStorage.setItem("eventsafeguardtoken", response.token);
        window.localStorage.setItem("user", response.claims.usercode);
        window.localStorage.setItem("fullname", response.claims.fullName);
        window.localStorage.setItem("companyname", response.claims.companyName);
        window.localStorage.setItem(
          "companyUniqueKey",
          response.claims.companyUniqueKey
        );
        window.location = "/chef-personnel-assign";
        setIsLoading(false);
      })
      .catch((response) => {
        let message = "Bir Hata Oluştu Tekrar Deneyiniz.";
        if (response && response.data && response.data.message) {
          message = t(response.data.message);
        }
        notification.error({ message });
        setIsLoading(false);
      });
  };

  const onChangeHandler = (e) => {
    setState({ ...loginState, [e.target.name]: e.target.value });
  };

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Lc_MKIdAAAAACKslmEJAHj9aTZ_elgNZZmyxbs3"
    >
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950 px-4">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src={getLogoPath()}
              alt="Logo"
              className="h-12 mx-auto dark:hidden"
            />
          </div>

          {/* Card */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-800 p-8">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Amir Girişi
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                TC Kimlik numaranız ile giriş yapın
              </p>
            </div>

            <form onSubmit={submit} className="space-y-4">
              {/* TC Kimlik */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                  TC Kimlik Numaranız
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    name="identityNumber"
                    value={loginState.identityNumber}
                    onChange={onChangeHandler}
                    placeholder="TC Kimlik Numarası"
                    maxLength={11}
                    required
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm placeholder-gray-400 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all"
                  />
                </div>
              </div>

              {/* Remember Me */}
              <div className="flex items-center justify-between py-0.5">
                <label className="flex items-center gap-2 cursor-pointer select-none group">
                  <input
                    type="checkbox"
                    id="rememberChefMe"
                    name="rememberChefMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="w-4 h-4 text-brand-600 bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 rounded focus:ring-brand-500 focus:ring-2 cursor-pointer accent-brand-500"
                  />
                  <span className="text-sm text-gray-600 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white transition-colors">
                    Beni Hatırla
                  </span>
                </label>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                disabled={!recaptchaStatus || isLoading}
                className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-brand-500 hover:bg-brand-600 disabled:bg-gray-300 dark:disabled:bg-gray-700 text-white font-medium text-sm rounded-lg transition-colors mt-2"
              >
                {isLoading ? (
                  <>
                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                    <span>Lütfen Bekleyiniz</span>
                  </>
                ) : (
                  <span>Giriş Yap</span>
                )}
              </button>
            </form>

            {/* Back to Login */}
            <div className="mt-6 text-center">
              <a
                href="/login"
                className="text-sm text-brand-500 hover:text-brand-600 font-medium transition-colors"
              >
                ← Normal Girişe Dön
              </a>
            </div>
          </div>

          <GoogleReCaptcha
            onVerify={() => setRecaptchaStatus(true)}
          />
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
};
